export default function useIEHelper () {
  function ObjectWrapper () {
  }
  ObjectWrapper.prototype.get = function (key) {
    return this[key] || null
  }
  ObjectWrapper.prototype.toString = function () {
    let s = ''
    for (const prop in this) {
      if (this.hasOwnProperty(prop) && prop !== 'browserIsDeprecated') {
        s = s + prop + '=' + this[prop] + '&'
      }
    }
    return s.substr(0, s.length - 1)
  }
  function URLSearchParamsWrapper (params) {
    let p = new URLSearchParams(params)
    if (p['_list']) {
      let r = new ObjectWrapper()
      r.browserIsDeprecated = true
      for (let i = 0; i < p['_list'].length; i++) {
        r[p['_list'][i]['name']] = p['_list'][i]['value']
      }
      return r
    }
    return p
  }
  return {
    URLSearchParamsWrapper
  }
}
